export const controller = {
    languageCode: 'en',
    fiatCoin: 'USD',
    erc4337: false,
};
